export default {
  install(Vue) {
    Vue.prototype.$clarity = {
      identify(userData) {
        if (window.clarity) {
          if (!userData.email) {
            console.error(
              "O campo 'email' é obrigatório para identificar o usuário no Clarity."
            );
            return;
          }

          window.clarity(
            "identify",
            userData.email,
            userData.sessionId,
            userData.pageId,
            userData.name
          );
        }
      },

      // Rastreia eventos customizados
      track(eventName, properties = {}) {
        if (window.clarity) {
          window.clarity("event", eventName, properties);
        }
      },

      // Atualiza dados da sessão
      updateSession(key, value) {
        if (window.clarity) {
          window.clarity("set", key, value);
        }
      }
    };
  }
};
